import { Box, Button, Typography } from "@mui/material";
import React from "react";
import Check from '../../images/success.png'
import { useNavigate } from "react-router";

function RegisterSuccess() {
    const navigate = useNavigate();
    const queryParameters = new URLSearchParams(window.location.search);
    const affiliateCode = queryParameters.get("affiliateCode");
    const handleClick = (e) => {
        navigate(`/?affiliateCode=${affiliateCode}`);
    }
  return (
    <Box sx={successStyle.containerBox}>
      <Box sx={successStyle.successBox}>
        <Typography variant="h1" sx={{fontSize: {lg: "36px", md: "28px", sm: "28px", xs: "22px"}}} >Thank you for registering for your Life Insurance Applications Portal! </Typography>
        <Box component="img" src={Check} sx={{ width: { lg: "120px" ,md:"91px", sm: "91px", xs: "40px"},  padding: {lg:"47px", md: "30px", sm: "30px", xs: "20px"}, borderRadius: "100px" }}/>
        <Button sx={successStyle.loginButton} onClick={handleClick}>Login</Button>
      </Box>
    </Box>
  );
}

export default RegisterSuccess;

const successStyle = {
  containerBox: {
    display: "flex",
    height: "100vh",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },

  successBox: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: { lg: "626px", md: "502px", sm: "502px", xs: "343px" },
    height: "auto",
    background: "#F5F7FF",
    margin: "100px auto",
    padding: { lg: "64px 52px", md: "40px 32px ", sm: "40px 32x", xs: "24px 16px" },
    borderRadius: "8px"
  },

  loginButton: {
    textTransform: "none",
    width: { lg: "50%", md: "50%", sm: "50%", xs: "60%" },
    height: "40px",
    backgroundColor: "#3C4FB9",
    color: "white",
    borderRadius: "100px",
    mt: "10px",
    "&:hover": {
      backgroundColor: "#9BA5DF",
      color: "#36414E",
    },
    "&:disabled": {
      backgroundColor: "#C4CAF1",
      color: "white",
      textTransform: "none",
    },
  },
};
